import { useEffect, useRef, useState } from "react";

// Tweens from the previous value (or 0 on first paint) to the new value over
// `durationMs`, calling `formatter(currentValue)` every frame so the displayed
// string ticks like a slot machine.
export default function AnimatedNumber({ value, formatter = (v) => v, durationMs = 900 }) {
  const target = Number.isFinite(Number(value)) ? Number(value) : 0;
  const [display, setDisplay] = useState(0);
  const fromRef = useRef(0);
  const lastTargetRef = useRef(0);
  const firstRunRef = useRef(true);

  useEffect(() => {
    fromRef.current = firstRunRef.current ? 0 : lastTargetRef.current;
    lastTargetRef.current = target;
    firstRunRef.current = false;

    if (fromRef.current === target) {
      setDisplay(target);
      return undefined;
    }

    const start = performance.now();
    let raf = requestAnimationFrame(function tick(now) {
      const t = Math.min(1, (now - start) / durationMs);
      const eased = 1 - Math.pow(1 - t, 3);
      setDisplay(fromRef.current + (target - fromRef.current) * eased);
      if (t < 1) raf = requestAnimationFrame(tick);
    });
    return () => cancelAnimationFrame(raf);
  }, [target, durationMs]);

  return <>{formatter(display)}</>;
}
